// src/pages/.../ManageMembers/utils/manageMembers.utils.js

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function readStoredUserInfo() {
  try {
    return JSON.parse(localStorage.getItem("userInfo") || "null");
  } catch (error) {
    console.error(
      "Impossible de lire les informations utilisateur stockées :",
      error,
    );

    return null;
  }
}

export function getInitials(adherent) {
  const prenomInitial = adherent?.prenom?.trim()?.[0] || "";
  const nomInitial = adherent?.nom?.trim()?.[0] || "";

  return `${prenomInitial}${nomInitial}`.toUpperCase() || "A";
}

export function getAdherentGroups(adherent) {
  if (Array.isArray(adherent?.Groups)) {
    return adherent.Groups;
  }

  if (Array.isArray(adherent?.groups)) {
    return adherent.groups;
  }

  return [];
}

export function getGroupDojo(group) {
  return group?.dojo || group?.Dojo || null;
}

export function getGroupDojoId(group) {
  return (
    getGroupDojo(group)?.id ??
    group?.dojo_id ??
    group?.dojoId ??
    null
  );
}

export function getGroupDojoName(group) {
  return (
    getGroupDojo(group)?.nom_dojo ||
    group?.nom_dojo ||
    "Lieu non renseigné"
  );
}

export function adherentBelongsToGroup(adherent, groupId) {
  return getAdherentGroups(adherent).some(
    (group) => String(group?.id) === String(groupId),
  );
}

export function getAdherentDojoNames(adherent) {
  return [
    ...new Set(
      getAdherentGroups(adherent)
        .map((group) => getGroupDojoName(group))
        .filter(
          (dojoName) =>
            dojoName && dojoName !== "Lieu non renseigné",
        ),
    ),
  ];
}

export function sanitizeFileName(value) {
  return String(value || "export")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-_]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
}

export function formatDateForDisplay(value) {
  if (!value) return "";

  const rawValue = String(value).slice(0, 10);
  const parts = rawValue.split("-");

  if (parts.length === 3) {
    const [year, month, day] = parts;

    if (year && month && day) {
      return `${day}/${month}/${year}`;
    }
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleDateString("fr-FR");
}

export function getLocalDateFileSuffix(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}